<template>
  <div class="vipJoin">
    <nav-bar nav-bar-type="transparent" :navBarTitle="navBarTitle" v-if="navBarTitle"></nav-bar>
    <!--正常页面-->
    <div v-if="loading">
      <!--头部-->
      <!--header-->
      <header class="vipJoin-header" :class="[showNavbar ? 'background1' : 'background']">
        <div class="phone-scroll">
          <img :src="vipLogo" class="phone-scroll-logo" />
          <number-swiper :dataList="vipHistoryList" v-if="vipHistoryList.length"></number-swiper>
        </div>
        <div class="consult" @click="getPhoneNumber">
          <img src="../../assets/img/vip/consult.png" alt="" />
          <span class="desc">咨询</span>
        </div>
      </header>
      <!--vip-->
      <div class="vip-card" v-if="vipCardList.length">
        <div class="vip-card-wrap" :style="{ width: vipCardList.length > 2 ? 119 * vipCardList.length + 'px' : '100%' }">
          <div
            class="vip-card-item"
            v-for="(item, index) in vipCardList"
            :class="{ 'active active1': index === currentVipIndex }"
            :style="{ width: vipCardList.length > 2 ? '104px' : '166px' }"
            :key="index"
            @click="chooseVip(index)"
          >
            <img v-if="item.iconUrl" class="label" :src="item.iconUrl" />
            <div class="title ellipsis">{{ item.name }}</div>
            <div class="price"><span>¥</span>{{ item.price }}</div>
            <template>
              <!--新人专享-->
              <div class="new" v-if="item.forNewUser">
                新boss专享
              </div>
              <div class="origin-price" v-else><span>¥</span>{{ item.originalPrice }}</div>
            </template>
            <div class="coupon" v-if="item.couponNameList.length">
              <span class="coupon-title">赠</span>
              <template>
                <span class="coupon-text" v-if="Number(item.couponTotalAmount)">{{ item.couponTotalAmount }}元优惠券</span>
                <span class="coupon-text" v-else>优惠券大礼包</span>
              </template>
            </div>
            <div class="choose" :class="{ chooseActive: index === currentVipIndex }"></div>
          </div>
        </div>
      </div>
      <!--支付方式-->
      <div class="pay" v-if="payTypeList.length">
        <div class="section-title">
          支付方式
        </div>
        <div class="pay-type">
          <div
            class="pay-type-item"
            :class="{ active: item.payType === payType }"
            v-for="(item, index) in payTypeList"
            :key="index"
            @click="choosePayType(item)"
          >
            <img class="icon-img" :src="item.icon" />
            <span>{{ item.payTypeName }}</span>
            <div class="choose" :class="{ chooseActive: item.payType === payType }"></div>
          </div>
        </div>
      </div>
      <!--其他购买方式-->
      <div class="pay buy-type">
        <div class="section-title">
          其他购买方式
        </div>
        <div class="pay-type">
          <div class="pay-type-item" @click="goPath('/vip/vipFree')">
            <span class="label">赠好友</span>
            <span class="text">赠送好友VIP</span>
          </div>
          <div class="pay-type-item" @click="goPath('/vip/vipCode')">
            <span class="text">使用会员兑换码</span>
          </div>
        </div>
      </div>
      <!--选择优惠券-->
      <div class="coupon-choose">
        <div class="coupon-choose-c">
          <van-cell
            title="使用优惠券"
            class="coupon-choose-use"
            is-link
            v-if="couponAmount"
            v-model="couponAmountText"
            @click="showCouponModal = true"
          />
          <van-cell title="使用优惠券" is-link v-else :value="canCouponNum ? '请选择' : '未发现可用优惠券'" @click="chooseCoupon" />
        </div>
      </div>
      <!-- 优惠券列表 -->
      <van-popup v-model="showCouponModal" round closeable position="bottom" style="height: 75%; background: #fdfdfd;" class="coupon-pop">
        <div class="coupon-list">
          <header>
            <h1 class="header-title">选择优惠券</h1>
            <p>
              共<span style="padding: 0 5px">{{ couponNumber }}</span
              >张优惠券
            </p>
          </header>
          <van-tabs v-model="couponName" animated>
            <van-tab :title="`可用(${canCouponNum})`" name="enableCoupon">
              <div class="tab-wrap">
                <coupon-list-item v-for="(item, index) in canCouponList" :info="item" :key="index" @useCoupon="useCoupon"></coupon-list-item>
                <no-data v-if="!canCouponNum" text="没有可用的优惠券" :type="3"></no-data>
              </div>
            </van-tab>
            <van-tab :title="`不可用(${disCouponNum})`" name="disableCoupon">
              <div class="tab-wrap">
                <coupon-list-item v-for="(item, index) in disCouponList" :info="item" :key="index" :disabled="true"></coupon-list-item>
                <no-data v-if="!disCouponNum" text="没有不可用的优惠券" :type="3"></no-data>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </van-popup>
      <!--&lt;!&ndash;我的专属权益&ndash;&gt;-->
      <right-list :infoList="rightList"></right-list>
      <!--占位-->
      <div class="placeholder-block"></div>
      <!--按钮-->
      <div class="btn-section">
        <div class="vip-btn-black" @click="goPay">
          <span class="desc">立即支付¥{{ amount }} {{ currentVipObj.forNewUser ? '享新人福利' : '成为VIP' }}</span>
          <span class="text" v-if="!currentVipObj.forNewUser">即刻对接万亿补贴</span>
        </div>
        <div class="vip-desc">
          <span class="vip-desc-l" data-sensors-click>支付即同意</span>
          <span class="vip-desc-r" @click="$router.push({ path: '/contract' })" data-sensors-click>政策补贴宝VIP用户协议</span>
        </div>
      </div>
      <a :href="'tel:' + phone" id="telphone" style="display: none"></a>
    </div>
    <!--支付失败页面展示-->
    <div v-if="payFail" class="pay-fail">
      <div class="desc">支付失败，请返回首页</div>
      <button class="btn btn-blue-transparent" @click="goPath('/home')">返回首页</button>
    </div>
    <!--外部浏览器支付时弹窗提示-->
    <van-popup v-model="payTipShow" :style="{ width: '70%' }">
      <div class="browsersharetip">
        <div>请在微信客户端关注“政策补贴宝”公众号进行付费操作</div>
        <p @click="payTipShow = false">知道了</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import NumberSwiper from './components/NumberSwiper'
import RightList from './components/rightList'
import CouponListItem from './components/CouponListItem'
import vipMixins from './mixins/vipMixins'
import NoData from '../../components/NoData'
import { mapGetters } from 'vuex'
import { getUrlParams, isEmptyObject, version } from '../../utils'
import { cardShareInfo, expertTelephone, reqGetVipList, showOrder } from '../../api';

export default {
  name: 'vipJoin',
  mixins: [vipMixins],
  components: {
    NumberSwiper,
    RightList,
    CouponListItem,
    NoData,
  },
  data() {
    return {
      showNavbar: false, // 是否显示navbar
      navBarTitle: '',
      loading: false,
      pageName: 'joinvip',
      vipLogo: require('../../assets/img/vip/vip-log.png'),
      vipHistoryList: [], // vip购买记录数据
      rightList: [],
      phone: '',
      rightObjList: [
        {
          // 小秘书
          infoTitle: '政策查看不限量',
          infoDesc: '可查看所有与您企业匹配的补贴优惠政策，不再错过从几千元到几百万的政策补贴，普通用户仅可查看一条。',
          infoLabelList: ['数量不限'],
          imgSrc: require('../../assets/img/vip/right-policy.png'),
        },
        {
          infoTitle: '专属政策小秘书',
          infoDesc: '系统自动跟踪中央部委、省市区县各级最新优惠补贴政策，政策小秘书第一时间推送，让您快人一步',
          infoLabelList: ['订阅推送'],
          imgSrc: require('../../assets/img/vip/right-secretary.png'),
        },
        {
          infoTitle: '政策专家专属咨询',
          infoDesc: '政策专家全程提供咨询服务，任何问题都可得到专家点对点、一对一精准帮助。',
          infoLabelList: ['政策专家'],
          imgSrc: require('../../assets/img/vip/right-consult.png'),
        },
        {
          infoTitle: '优惠券大礼包',
          imgSrc: require('../../assets/img/vip/right-coupon.png'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['vipLevel']),
  },
  watch: {
    canCouponList(newValue) {
      this.canCouponList = newValue
    },
    disCouponList(newValue) {
      this.disCouponList = newValue
    },
  },
  created() {
    this.showNavbar = Number(localStorage.getItem('clearNav')) === 1 ? true : false
    this.s = localStorage.getItem('s') || ''
  },
  async mounted() {
    // 微信分享卡片信息
    if(version().weixin){
      this.defalutShare()
    }
    this.navBarTitle = localStorage.getItem('vipLevel') && Number(localStorage.getItem('vipLevel')) === 1 ? '会员续费': '开通会员'
    this.isWx = version().weixin // 是否处于微信环境
    if (this.isWx) {
      // 获取code
      this.code = getUrlParams('code')
      if (this.code) {
        this.payUrl = getUrlParams('payUrl')
        window.location.href = `${this.payUrl}&mchnNo=TOJOYPOLICY=&code=${this.code}`
      }
      // 重定向获取预支付订单信息
      const prePayInfo = decodeURIComponent(getUrlParams('prePayInfo'))
      this.requestOrderId = decodeURIComponent(getUrlParams('userOrderNo'))
      // 调起支付
      if (!isEmptyObject(prePayInfo)) {
        // 调起微信支付
        this.initBridge(prePayInfo)
      } else {
        this.initData()
      }
    } else {
      this.initData()
    }
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('vipLevel') && Number(localStorage.getItem('vipLevel')) === 1) {
      to.meta.title = '会员续费'
    } else {
      to.meta.title = '开通会员'
    }
    next()
  },
  methods: {
    async defalutShare() {
      let params = {
        type: 7   // 开通会员专属
      }
      let res = await cardShareInfo(params)
      if(res && res.ok){
        let data = res.data
        if(this.s !== 'BS'){
          this.WechatShare({
            title: data.title,
            desc: data.desc,
            imgUrl: data.imgUrl,
            link: data.linkUrl
          },window.initUrl ? window.initUrl: '')
        }
      }
    },
    // 初始化数据
    initData() {
      // 获取轮播数据
      this.getHistoryOrder()
      // 获取vip套餐
      this.getVipList()
      // 获取支付列表
      this.getPayTypeList()
    },
    // 获取轮播数据
    getHistoryOrder() {
      showOrder().then(res => {
        if (res && res.ok) {
          this.vipHistoryList = res.data
        }
      })
    },
    // 获取vip套餐
    getVipList() {
      reqGetVipList({ channel: 3, type: 0 }).then(res => {
        this.vipCardList = res.data
        this.chooseVip(0)
        this.loading = true
      })
    },
    // 选择vip套餐
    chooseVip(index) {
      this.currentVipIndex = index
      this.currentVipObj = this.vipCardList[this.currentVipIndex] || {}
      this.couponAmountText = ''
      this.couponAmount = 0
      this.amount = this.currentVipObj.price
      this.getChooseCouponList()
      this.dealRightList() // 处理会员权益
    },
    // 处理会员权益
    dealRightList() {
      // 处理会员权益list
      this.rightList = []
      let key = 0
      this.$set(this.rightList, 0, this.rightObjList[0])
      if (this.currentVipObj.policySecretary) {
        this.$set(this.rightList, ++key, this.rightObjList[1])
      }
      if (this.currentVipObj.policyExpertTimes && this.currentVipObj.policyExpertTimes !== 0) {
        this.$set(this.rightList, ++key, this.rightObjList[2])
      }
      // 优惠券
      if (this.currentVipObj.couponNameList && this.currentVipObj.couponNameList.length > 0) {
        this.$set(
          this.rightObjList[3],
          'infoDesc',
          this.currentVipObj.couponTotalAmount ? `赠送价值${this.currentVipObj.couponTotalAmount}元优惠券大礼包 ` : '赠送优惠券大礼包'
        )
        this.$set(this.rightObjList[3], 'infoLabelList', this.currentVipObj.couponNameList)
        this.$set(this.rightList, ++key, this.rightObjList[3])
      }
      this.couponTotalAmount = this.currentVipObj.couponTotalAmount || 0
    },
    //  调起电话
    async call() {
      let comment = document.getElementById('telphone')
      if (document.all) {
        comment.click()
      } else if (document.createEvent) {
        let ev = document.createEvent('MouseEvents')
        ev.initEvent('click', false, true)
        comment.dispatchEvent(ev)
      }
    },
    // 获取普通客服电话
    async getPhoneNumber() {
      let params = {
        consultType: 1,
      }
      await expertTelephone(params).then(res => {
        this.phone = res.data.expertMobile
      })
      // 客服电话埋点
      // eslint-disable-next-line
      sensors.track('customerServicePhoneClick', {
        customer_service_phone: this.phone
      });
      this.call()
    },
  },
}
</script>

<style lang="less" scoped>
.vipJoin {
  padding-bottom: 90px;
  .pay-fail {
    width: 345px;
    margin: 150px auto;
    .desc {
      width: 100%;
      text-align: center;
      font-size: 16px;
    }
    .btn {
      margin-top: 50px;
    }
  }
  .section-title {
    font-size: 18px;
    font-weight: 400;
    color: rgba(54, 61, 73, 1);
    text-align: left;
    margin: 20px 16px 0px 16px;
  }
  .vipJoin-header {
    width: 375px;
    position: relative;
    .consult {
      display: inline-block;
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      bottom: 65px;
      right: 17px;
      > img {
        width: 18px;
        height: auto;
      }
      .desc {
        display: inline-block;
        margin-top: 4px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 10px;
      }
    }
    .phone-scroll {
      width: 343px;
      height: 50px;
      background: url('../../assets/img/vip/vipcard-bg.png') no-repeat center;
      background-size: 100% 100%;
      margin: 0 auto;
      position: absolute;
      bottom: 0px;
      left: 16px;
      &-logo {
        width: 64px;
        height: 12px;
        position: absolute;
        left: 16px;
        top: 19px;
      }
    }
  }
  .vipJoin-header.background {
    height: 110px;
    background: url('../../assets/img/vip/header-bg1.png') no-repeat center;
    background-size: 100% 100%;
  }
  .vipJoin-header.background1 {
    padding-top: 40px;
    height: 170px;
    background: url('../../assets/img/vip/header-bg3.png') no-repeat center;
    background-size: 100% 100%;
  }
  .placeholder-block {
    height: 20px;
    width: 100%;
    background: #f5f5f5;
  }
  // 选择优惠券
  .coupon-choose {
    padding: 10px 0px;
    background: #f5f5f5;
    /deep/ .van-cell__title {
      color: @darkBlack;
      font-size: 16px;
    }
    /deep/ .van-cell__value {
      color: #cccccc;
    }
    /deep/ .van-cell {
      padding: 20px 16px;
    }
    /deep/ .van-cell__right-icon {
      color: #cccccc;
    }
    .coupon-choose-use {
      /deep/ .van-cell__value {
        color: #fa5741;
      }
    }
  }
  .coupon-pop {
    /deep/ .van-popup__close-icon {
      color: #999999;
    }
    /deep/ .van-tab {
      flex: none;
      padding: 0px;
      margin-right: 32px;
      font-size: 16px;
    }
  }
  .coupon-list {
    width: 100%;
    header {
      padding: 0 20px;
      margin-top: 60px;
      display: flex;
      align-items: flex-end;
      > p {
        margin-left: 10px;
        color: @subBlack;
        font-size: 12px;
        line-height: 12px;
        > span {
          color: @darkBlack;
        }
      }
      .header-title {
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 18px;
      }
    }
    /deep/ .van-tabs {
      margin-top: 10px;
    }
    /deep/ .van-tabs__wrap {
      width: 335px;
      margin: 0 auto;
    }
    /deep/ .van-tabs__line {
      width: 20px !important;
      height: 2px;
      background: rgba(57, 141, 255, 1);
    }
    /deep/ .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border-width: 0;
      border-bottom-width: 1px;
    }
  }
  .coupon-list  /deep/  .van-tabs__content--animated{
	height: calc( 75vh - 134px );
	overflow-y: scroll;
  }
}
</style>
